<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite nivo:
    </h2>

    <LevelForm
      @save="save"
      @cancel="cancel"
      :level="level"
    />

    <div class="row mt-10">
      <div class="col">
        <h2>
          Skupine:
        </h2>
      </div>
      <div class="col">
        <PopupPickerCategory
          class="float-right"
          :levelId="id"
          :levelCategories="levelCategories"
          :allCategories="allCategories"
        />
        <v-btn
          color="#0F998E"
          class="white--text float-right mr-5"
          @click="saveOrder"
        >
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
      </div>
    </div>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Skupina
                </th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row v-dragula="localLevelCategories" drake="categories">

      <v-col cols="12" class="pt-0 pb-0" v-for="item of localLevelCategories" :key="item.id">
        <TitleOnlyCard
          :style="{'border-left': `5px solid ${item.color}`}"
          :title="item.name"
          :draggable="true"
          @edit="$router.push({name: 'MyCompanyCategoriesEdit', params: {id: item.id}})"
          @delete="deleteCategory({ levelId: id, categoryId: item.id })"
        />
      </v-col>
    </v-row>

    <div class="row mt-10">
      <div class="col">
        <h2>
          Artikli:
        </h2>
      </div>
      <div class="col">
        <PopupPickerArticle
          :levelId="id"
          :levelCategories="levelCategories"
          :levelArticles="levelArticles"
          :allArticles="allArticles"
        />
      </div>
    </div>
    <v-row>
      <v-col
        cols="12" md="6" lg="4" xl="3"
        v-for="item of levelArticles" :key="item.id"
      >
        <ArticleCard
          :article="item"
          :editable="false"
          @delete="deleteArticle({ levelId: id, articleId: item.id })"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import LevelForm from '@/components/LevelForm'
import PopupPickerCategory from '@/components/PopupPickerCategory'
import PopupPickerArticle from '@/components/PopupPickerArticle'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import ArticleCard from '@/components/ArticleCard'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    LevelForm,
    PopupPickerCategory,
    PopupPickerArticle,
    TitleOnlyCard,
    ArticleCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      localLevelCategories: []
    }
  },
  computed: {
    level () {
      return this.$store.state.levels.items[this.id]
    },
    allCategories () {
      return objectToArray(this.$store.state.categories.items)
    },
    allArticles () {
      return objectToArray(this.$store.state.articles.items)
    },
    levelCategories () {
      return objectToArray(this.$store.state.levels.categories[this.id])
    },
    levelArticles () {
      return objectToArray(this.$store.state.levels.articles[this.id])
    }
  },
  methods: {
    ...mapActions('levels', ['loadItem', 'saveItem', 'deleteCategory', 'deleteArticle', 'updateCategoriesOrder']),
    ...mapActions('levels', { loadLevelCategories: 'loadCategories', loadLevelArticles: 'loadArticles' }),
    ...mapActions('categories', { loadAllCategories: 'loadItems' }),
    ...mapActions('articles', { loadAllArticles: 'loadItems' }),
    save ({ data }) {
      saveItem(data, 'MyCompanyLevels', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyLevels' })
    },
    saveOrder () {
      const updates = []
      this.localLevelCategories.forEach((item, i) => {
        updates.push({
          id: item.id,
          sort_order: i + 1
        })
      })
      this.updateCategoriesOrder({ updates, levelId: this.id })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    }
  },
  created () {
    this.loadItem(this.id)
      .then(level => {
        Promise.all([
          this.loadAllCategories(),
          this.loadAllArticles(),
          this.loadLevelCategories(this.id),
          this.loadLevelArticles(this.id)
        ])
          .then(done => {
            this.localLevelCategories = this.levelCategories
            this.asyncDataStatus_fetched()
          })
      })
  },
  watch: {
    levelCategories (newLevelCategories) {
      this.localLevelCategories = newLevelCategories
    }
  }
}
</script>
